import { GLOBAL_EXPORT_BUTTON_ENABLED } from '../../../constants/user';

export const NEWS_PAGE_PAGE_INFO = {
  title: 'News',
};

export const EXPORT_BUTTON_ENABLED = [
  ...GLOBAL_EXPORT_BUTTON_ENABLED,
];

export const NEWS_PAGE_FORM_INITIAL_DATA = {
  // main
};

export const NEWS_PAGE_MAIN_FIELDS = [
  {
    type: 'textField',
    label: 'Title',
    name: 'title',
    placeholder: 'Title',
  },
  {
    type: 'select',
    label: 'Status',
    name: 'status',
    placeholder: 'Status',
    options: [],
    className: 'select',
  },
];

export const INITIAL_FILTERS_STATE = {
  sort_by: 'created_at',
  order: 'desc',
};
